export enum ProsecutionFactCheckResult {
	SufficientForInvestigation = 1,
	NeedsCompletion = 2,
}
